import { Component, NgZone, OnInit } from '@angular/core';
import { CartService } from '../../services/cart/cart.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { UpdateCart, MoveToWishList, CheckInventoryInStock } from '../../models/cart';
import { AddressService } from '@app/shared/services/address/address.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { IPayPalConfig, ICreateOrderRequest, IClientAuthorizeCallbackData  } from 'ngx-paypal';
import { Order } from '../../models/order';
import { OrderStatus, PaymentType, CryptoKeyValue } from '@app/shared/constants';
import { OrderService } from '@app/shared/services/order/order.service';
import { MessageService } from '@app/shared/services/common/message.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { environment } from '@env/environment';
import { GetCartItemsInterface } from '@app/feature/end-user/services/cart/GetCartItems.interface';
import { GetAllAddressInteface } from '../../../../shared/services/address/getAllAddress.inteface';
import * as braintree from 'braintree-web';
import { BraintreeService } from '../../../../shared/services/braintree/braintree.service';
import { EncrDecrService } from '../../../../shared/services/encr-decr-service.service';
import { CommonService } from '../../../../shared/services/common/common.service';


interface ResponseApi {
  StatusCode: number;
  Message: string;
}
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  isLinear!: any;
  parentRouteParam !: any;

  selectedIndex = 0; // Mat stepper step index

  cartItems: GetCartItemsInterface[] = [];
  cartTotal: any;
  deliveryCost: any;
  loginUserId: any;
  storeId: any;
  userRole: any;
  updateCart !: UpdateCart;
  CheckInventoryInStockModel: CheckInventoryInStock[]=[];
  cartItemsId: number[];
  moveToWishList !: MoveToWishList;
  public payPalConfig?: IPayPalConfig;  // for paypal configuration
  order !: Order;
  AddressId: any;
  selectedAddress: GetAllAddressInteface;
  guestEmail: any;
  //Braintree
  amount: string;
  hostedFieldsInstance: braintree.HostedFields;
  UserId: any;
  isCreditCardFormLoad: boolean;
  cardholderEmailId: boolean;
  showBraintree: boolean;
  costShipPerItem = 0.80;
  initialShipCost = 5.95;
  DiscontAmount = 0;
  totalQuantity: number = 0;
  diliverCostShow: boolean = false;
  thirdPartyShipping: boolean = false;
  // -------------------------------------------------------------------------------------------------------------------
  constructor(
    private cartservice: CartService,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private orderService: OrderService,
    private messageService: MessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cp: CurrencyPipe,
    private addressService: AddressService,
    private errorhandlerService: ErrorhandlerService,
    private brainTreeService: BraintreeService,
    private EncrDecr: EncrDecrService,
    private commonService: CommonService,
    private zone: NgZone
  ) {

    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = params['storename'];
      })
    }
  }




  ngOnInit() {    
    this.brainTreeService.GetPaymentToken().subscribe((res) => {
      if (res.StatusCode === 200) {      
        localStorage.setItem('clientToken', res.Data.ResponseData);
      }
    }, (error: any) => {
      this.errorhandlerService.handleError(error);
    });

    this.loginUserId = localStorage.getItem('userId');
    this.storeId = localStorage.getItem('storeId');
    this.userRole = localStorage.getItem('role');
    const guestId = this.getGuestId();
    this.loginUserId = this.loginUserId ? this.loginUserId : this.getGuestId();
    // this.storeUrl = localStorage.getItem('storeUrl');
    this.cartItems = [];
    if ((this.loginUserId && this.userRole && this.userRole === 'EndUser') || guestId) {
      this.cartTotal = 0;
      this.fn_GetCartItems();
      this.fn_InitializeUpdateCartModal();
      this.fn_InitializeOrderModel();
      this.cartItemsId = [];
    }
    if(this.loginUserId && this.userRole && (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember')){
      this.fn_GetThirdPartyShipping();

    }
    this.showBraintree = true;
  }

  createBraintreeUI() {
    // this.loader.show();
    braintree.client.create({
      authorization: localStorage.getItem('clientToken'),
    }).then((clientInstance) => {
      braintree.hostedFields.create({
        client: clientInstance,
        styles: {
          // Override styles for the hosted fields
          'input': {
            'color': '#282c37',
            'transition': 'color 0.1s'
          },
          // Style the text of an invalid input
          'input.invalid': {
            'color': '#E53A40'
          },
          // placeholder styles need to be individually adjusted
          '::-webkit-input-placeholder': {
            'color': 'rgba(0,0,0,0.6)'
          },
          ':-moz-placeholder': {
            'color': 'rgba(0,0,0,0.6)'
          },
          '::-moz-placeholder': {
            'color': 'rgba(0,0,0,0.6)'
          },
          ':-ms-input-placeholder': {
            'color': 'rgba(0,0,0,0.6)'
          },
          // prevent IE 11 and Edge from
          // displaying the clear button
          // over the card brand icon
          'input::-ms-clear': {
            opacity: '0'
          }
        },
        // The hosted fields that we will be using
        // NOTE : cardholder's name field is not available in the field options
        // and a separate input field has to be used incase you need it
        fields: {
          cardholderName: {
            selector: '#cc-name',
            placeholder: 'Name as it appears on your card'
          },
          number: {
            selector: '#card-number',
            placeholder: '1111 1111 1111 1111'
          },
          cvv: {
            selector: '#cvv',
            placeholder: '123'
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YY'
          },
          postalCode: {
            selector: '#cc-postal-code',
            placeholder: '11111'
          },
        }

      }).then((hostedFieldsInstance) => {
        this.loader.hide();

        this.hostedFieldsInstance = hostedFieldsInstance;
        //this.isCreditCardFormLoad = true;

        hostedFieldsInstance.on('validityChange', (event) => {
          // Check if all fields are valid, then show submit button
          var formValid = Object.keys(event.fields).every(function (key) {
            return event.fields[key].isValid;
          });

          this.zone.run(() => {
            if (formValid) {
              this.isCreditCardFormLoad = true;
            } else {
              this.isCreditCardFormLoad = false;
            }
          });
        });
    
        hostedFieldsInstance.on('empty', function (event) {
            document.querySelector('#card-image').setAttribute("class", "");
            document.querySelector('#card-image').setAttribute("title", "");
        });
    
        hostedFieldsInstance.on('cardTypeChange', function (event) {
          // Change card bg depending on card type
          if (event.cards.length === 1) {
            document.querySelector('#card-image').setAttribute("class", "");
            document.querySelector('#card-image').classList.add(event.cards[0].type);
            document.querySelector('#card-image').setAttribute("title", event.cards[0].niceType);
            
            // Change the CVV length for AmericanExpress cards
            if (event.cards[0].code.size === 4) {
              hostedFieldsInstance.setAttribute({
                field: 'cvv',
                attribute: 'placeholder',
                value: '1234'
              });
            } 
          } else {
            hostedFieldsInstance.setAttribute({
              field: 'cvv',
              attribute: 'placeholder',
              value: '123'
            });
          }
        });
        
      });
    });
  }

  tokenizeUserDetails() {
    let state = this.hostedFieldsInstance._state;
    Object.keys(state.fields).forEach(function(field) {
      if (!state.fields[field].isValid) {
        return false;
      } 
    }); 

    this.loader.show();
    this.hostedFieldsInstance.tokenize().then((payload) => {
   
      // submit payload.nonce to the server from here
      this.fn_PaymentSuccessonCard(payload);

    }).catch((error) => {
      this.notificationService.error(error.message + ',' + 'invalid field ' + error.details.invalidFieldKeys[0], 'Error')
      console.log(error);
      this.loader.hide();
      // perform custom validation here or log errors
    });
  }


  getGuestId() {
    const guestId = localStorage.getItem('guestId');
    if (guestId) {
      return guestId;
    } else {
      const id = Math.ceil(Math.random() * 100000000);
      localStorage.setItem('guestId', id.toString());
      return id.toString();
    }
  }

  fn_InitializeOrderModel() {
    this.order = {
      AddressId: 0,
      PayPalOrderId: '',
      PaypalPayerId: '',
      PaypalPaymentId: '',
      PaypalPaymentToken: '',
      PaymentMethod: 0,
      TotalPrice: 0.0,
      DeliveryCost: 0.0,
      Status: 0,
      UserId: this.loginUserId,
      GuestId: null,
      StoreId: this.storeId,
      IsSampleOrder: false,
      CartItems: [],
      PrintingCost: 0,
      Discount: 0,
      IsWareHouseProduct: false,
      PaymentNonce: ''    
    };
  }

  fn_InitializeUpdateCartModal() {
    this.updateCart = {
      CartItemId: 0,
      IsDecrement: false,
      IsIncrement: false,
      OperationType: 0,
      UserId: this.loginUserId,
      StoreId: this.storeId
    };
    this.moveToWishList = {
      CartItemId: 0,
      UserId: this.loginUserId,
      StoreId: this.storeId
    };
  }

  fn_GetThirdPartyShipping() {
    this.cartservice.GetThirdPartyShipping(this.storeId).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.thirdPartyShipping = res.Data.ResponseData;
      }
    }, (error: any) => {
      this.errorhandlerService.handleError(error);
    });
  }

  /** function to load items in cart for specifc user of store */
  fn_GetCartItems() {
    this.loader.show();
    this.cartservice.GetCartItems(this.loginUserId, this.storeId).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.totalQuantity = 0;
        // If there are any items in cart
        if (res.Data.ResponseData.length > 0) {
          this.cartItems = res.Data.ResponseData;
        //  localStorage.setItem('storeId', res.Data.ResponseData[0].StoreId.toString());
          const r = {
            cartItemCount: this.cartItems.length
          };
          this.messageService.sendCartCount(r);
          if (this.cartItems && this.cartItems.length > 0) {      

            for (let i = 0; i < this.cartItems.length; i++) {

              var finalCost = 0;
              var IsEmbroideryType = this.cartItems[i].IsEmbroideryType
              this.totalQuantity += this.cartItems[i].Quantity;
              // if store admin that means sample order
              if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
                //if inksoft product
                if (!this.cartItems[i].IsWareHouseProduct) {
                  if (IsEmbroideryType)
                    finalCost = this.commonService.fn_CalculateTotalCost(this.cartItems[i].UnitPrice, this.cartItems[i].FinshingPrice, this.cartItems[i].EmbroideryCost, this.cartItems[i].ProductSidesCount, 0, IsEmbroideryType);   
                  else
                    finalCost = this.commonService.fn_CalculateTotalCost( this.cartItems[i].UnitPrice , this.cartItems[i].FinshingPrice , this.cartItems[i].PrintingCost ,this.cartItems[i].ProductSidesCount ,0);
                  if (this.cartItems[i].Discount > 0 || this.cartItems[i].Discount != null) {
                    finalCost = this.commonService.fn_calculateDiscount(finalCost, this.cartItems[i].Discount);
                    
                  }
                  
                }
                else {
                  // if  warehouse  product
                  finalCost = this.cartItems[i].UnitPrice;
                }
                //Apply discount if has any   
              }
              else if (this.userRole === 'EndUser' || this.userRole === "GuestUser" || this.userRole === null || this.userRole === undefined) {
                
                if (!this.cartItems[i].IsWareHouseProduct == true) {
                  if (IsEmbroideryType)
                    finalCost = this.commonService.fn_CalculateTotalCost(this.cartItems[i].UnitPrice, this.cartItems[i].FinshingPrice, this.cartItems[i].EmbroideryCost, this.cartItems[i].ProductSidesCount, this.cartItems[i].RetailPrice, IsEmbroideryType);
                  else 
                    finalCost = this.commonService.fn_CalculateTotalCost(this.cartItems[i].UnitPrice, this.cartItems[i].FinshingPrice, this.cartItems[i].PrintingCost, this.cartItems[i].ProductSidesCount, this.cartItems[i].RetailPrice);
                } else {
                  // if warehouse product
                  finalCost = this.cartItems[i].TotalPrice;
                }

              }
              this.cartItems[i].TotalPrice = finalCost;
            };


            var quantity = this.cartItems.map((x: any) => x.Quantity).reduce((accumulator, currentValue, currentIndex, array) =>
              accumulator + currentValue
            );

            if(this.thirdPartyShipping)
              this.deliveryCost = 0;
            else
              this.deliveryCost = ((quantity - 1) * this.costShipPerItem) + this.initialShipCost;

            this.cartTotal = this.cartItems.map((x: any) => x.TotalPrice * x.Quantity).reduce((accumulator, currentValue,) =>
              accumulator + currentValue
            );
          }
          // Setting printing cost in order model -------------------
          this.order.PrintingCost = this.cartItems[0].PrintingCost;
          // ---------------------------------------------------------
          this.loader.hide();
          // Initialize papypal config
          this.fn_PaypalInitConfig();
        } else { // If there are no items in cart, than set the cart count in header as 0
          this.cartItems = [];
          const r = {
            cartItemCount: 0
          };
          this.messageService.sendCartCount(r);
          this.loader.hide();
        }
      } else {
        this.cartItems = [];
        this.cartTotal = 0;
        this.loader.hide();
      }
    }, (error: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(error);
    });
  }

  /** function to move to wishlist */
  fn_MoveToWishList(cartItemId: number) {
    this.loader.show();
    this.moveToWishList.CartItemId = cartItemId;
    this.cartservice.MoveToWishList(this.moveToWishList).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.cartTotal = 0;
        this.fn_GetCartItems();
        this.loader.hide();
      } else {
        this.loader.hide();
      }
      this.fn_InitializeUpdateCartModal();
    }, (error: any) => {
      this.fn_InitializeUpdateCartModal();
      this.loader.hide();
      this.errorhandlerService.handleError(error);
    });
  }

  /** function to remove item from cart */
  fn_RemoveCartitem(cartItemId: number) {
    this.loader.show();
    this.updateCart.CartItemId = cartItemId;
    // OperationType 2 means Delete
    this.updateCart.OperationType = 2;
    this.cartservice.UpdateCart(this.updateCart).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.cartTotal = 0;
        this.fn_GetCartItems();
        this.loader.hide();
      } else {
        this.loader.hide();
      }
      this.fn_InitializeUpdateCartModal();
    }, (error: any) => {
      this.fn_InitializeUpdateCartModal();
      this.loader.hide();
      this.errorhandlerService.handleError(error);
    });
  }

  /** Function to increment/decrement quantity */
  fn_UpdateQty(cartItemId: number, type: string) {
    this.loader.show();
    type === 'INC' ? this.updateCart.IsIncrement = true : type === 'DEC' ? this.updateCart.IsDecrement = true :
      this.updateCart.IsDecrement = false;

    this.updateCart.CartItemId = cartItemId;
    // OperationType 1 means Update
    this.updateCart.OperationType = 1;
    this.cartservice.UpdateCart(this.updateCart).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_GetCartItems();
        this.loader.hide();
      } else {
        this.notificationService.info(res.Message, 'Info');
        this.loader.hide();
      }
      this.fn_InitializeUpdateCartModal();
    }, (error: any) => {
      this.fn_InitializeUpdateCartModal();
      this.loader.hide();
      this.errorhandlerService.handleError(error);
    });
  }
  // paypal gateway configuration
  fn_PaypalInitConfig(): void {
    this.payPalConfig = {
      currency: 'USD',
      clientId: environment.paypalPublicKey,
      createOrderOnClient: (data): ICreateOrderRequest => {
        return {
          intent: 'CAPTURE',
          purchase_units: [{
            amount: {
              currency_code: 'USD',
              value: (this.cp.transform(this.cartTotal + this.deliveryCost, '', '', '1.2-2')).toString(),
              breakdown: {
                item_total: {
                  currency_code: 'USD',
                  value: (this.cp.transform(this.cartTotal + this.deliveryCost, '', '', '1.2-2')).toString()
                }
              }
            },
            items: [{
              name: this.loginUserId,
              quantity: '1',
              category: 'PHYSICAL_GOODS',
              unit_amount: {
                currency_code: 'USD',
                value: (this.cp.transform(this.cartTotal + this.deliveryCost, '', '', '1.2-2')).toString()
              },
            }]
          }]
        };
      },
      advanced: {
        commit: 'true'
      },
      style: {
        label: 'pay',
        layout: 'horizontal'
      },
      
      onApprove: (data, actions) => {
      },
      onClientAuthorization: (data: IClientAuthorizeCallbackData) => {
        this.fn_PaymentSuccess(data);
      },
      onCancel: (data, actions) => {
        window.location.reload();
        this.notificationService.info('Your transaction has been cancelled', 'Payment');
      },
      onError: err => {
        this.router.navigate([this.parentRouteParam + '/paymentfailed']);
        window.location.reload();
      },
      onClick: (data, actions) => {
      },
    };
  }

  /** Function called after successfull payment via paypal
   * @param data response from paypal gateway on payment success
   */
  fn_PaymentSuccess(data: IClientAuthorizeCallbackData) {
    this.zone.run(() => {
      this.loader.show();

      // this model contains all paypal transaction return data and goes to api to be saved in database
      this.fn_GetCartItemsId();
      this.order.PaymentMethod = 2;
      this.order.PayPalOrderId = data.id;
      this.order.PaypalPayerId = data.payer.payer_id;
      this.order.PaypalPaymentId = data.id;
      this.order.PaypalPaymentToken = data.id;
      this.order.Status = OrderStatus.Ordered;
      this.order.UserId = this.userRole ? this.loginUserId : null;
      this.order.GuestId = this.userRole ? null : this.loginUserId;
      this.order.TotalPrice = Number(this.cp.transform(this.cartTotal + this.deliveryCost, '', '', '1.2-4'));
      this.order.DeliveryCost = Number(this.cp.transform(this.deliveryCost, '', '', '1.2-4'));
      this.order.Discount = Number(this.cp.transform(this.DiscontAmount, '', '', '1.2-2'));
      this.order.PaymentMethod = PaymentType.Paypal;    
      if (this.userRole == "StoreAdmin" || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember')
        this.order.IsSampleOrder = true;
      else
        this.order.IsSampleOrder = false;
      
      this.orderService.CreateOrder(this.order).subscribe((res: any) => {

        if (res.StatusCode === 200) {
          let orderNumber = res.Data.ResponseData;
          this.cartTotal = 0;
          this.fn_GetCartItems();
          this.loader.hide();
          localStorage.setItem('cartItemCount', '0');
          this.notificationService.success(res.Message, 'Order');
          if (this.userRole == "EndUser") {
            this.fn_OpenOrderConfirmationDialog(orderNumber);
          }
          else if (this.userRole == "StoreAdmin" || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
            this.router.navigate(['store/orderdetail', orderNumber]);
          }
          else {
            this.router.navigate([this.parentRouteParam + '/orderdetail', orderNumber]);
          }

        } else if (res.StatusCode === 400) {
          this.notificationService.error(res.Message, 'Order');
          this.loader.hide();
        } else {
          this.notificationService.error('An error occured', 'Order');
          console.log(res.Message);
          this.loader.hide();
        }
      }, (err: any) => {
        // this.notificationService.error('An error occured', 'Order');
        this.errorhandlerService.handleError(err);
        this.loader.hide();
      });
    });
  }

  fn_PaymentSuccessonCard(payload) {
    this.loader.show();
    
    this.fn_GetCartItemsId();
    this.order.PaymentMethod = 1;
    this.order.PaymentNonce = payload.nonce;
    if (this.userRole == "StoreAdmin" || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember')
      this.order.IsSampleOrder = true;
    else
      this.order.IsSampleOrder = false;

    this.order.Status = OrderStatus.Ordered;
    this.order.UserId = this.userRole ? this.loginUserId : null;
    this.order.GuestId = this.userRole ? null : this.loginUserId;
    this.order.TotalPrice = Number(this.cp.transform(this.cartTotal + this.deliveryCost, '', '', '1.2-2'));
    this.order.DeliveryCost = Number(this.cp.transform(this.deliveryCost, '', '', '1.2-2'));
    this.order.Discount = Number(this.cp.transform(this.DiscontAmount, '', '', '1.2-2'));
    this.order.PaymentMethod = PaymentType.CreditCard;
    this.orderService.CreateOrder(this.order).subscribe((res: any) => {
      if (res.StatusCode === 200) { 
        let orderNumber = res.Data.ResponseData;       
        this.cartTotal = 0;
        this.fn_GetCartItems();
        this.loader.hide();
        localStorage.setItem('cartItemCount', '0');
        this.notificationService.success(res.Message, 'Order');
        if (this.userRole == "EndUser") {
          this.fn_OpenOrderConfirmationDialog(orderNumber);
        }
        else if (this.userRole == "StoreAdmin" || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
          this.router.navigate(['store/orderdetail', orderNumber]);
        }
        else {
          this.router.navigate([this.parentRouteParam + '/orderdetail', orderNumber]);
        }

      } else if (res.StatusCode === 400) {
        this.notificationService.error(res.Message, 'Order');
        this.loader.hide();
      } else {
        this.notificationService.error('An error occured', 'Order');
        console.log(res.Message);
        this.loader.hide();
      }
    }, (err: any) => {
      // this.notificationService.error('An error occured', 'Order');
      this.errorhandlerService.handleError(err);
      this.loader.hide();
    });
  }

  getAddress(address: GetAllAddressInteface) {
    this.selectedAddress = address;
    if(address){
      this.order.AddressId = address.AddressId;
    }
    else{
      this.order.AddressId = 0;
    }
  }
  /** Function to return cart items id */
  fn_GetCartItemsId() {
    this.order.CartItems = [];
    this.cartItems.map((item) =>
      this.order.CartItems.push(item.CartItemId)
    );
  }


  /** Func to openorder confimation dialog once order is successfully placed */
  fn_OpenOrderConfirmationDialog(orderno: any) {
    // window.location.reload();
    this.router.navigate([this.parentRouteParam + '/orderconfirmation', orderno]);
  }

  /** Func called on mat stepper step change event */
  public selectionChange($event: StepperSelectionEvent): void {
    if ($event.selectedIndex === 0) {
      return; // First step is still selected
    }
    if ($event.selectedIndex === 2) {
    } else {
      this.selectedIndex = $event.selectedIndex;
    }
  }


  showPaymentWindow(amount: any) {
    this.createBraintreeUI();
    this.showBraintree = false;
    this.amount = amount;
  }
  fn_GetShippingCost() {
    this.guestEmail = this.selectedAddress.Email;
    var country_code = this.selectedAddress.CountryCode;

    if(this.thirdPartyShipping){
      this.deliveryCost = 0;
      this.diliverCostShow = true;
      this.loader.hide();
    }
    else{
      this.loader.show();
      var itemInfo = [];
      this.cartItems.forEach(x => { itemInfo.push({'ItemId' : x.CartItemId, 'Qty' : x.Quantity })});
      var payload = {
        CountryCode : country_code,
        ShopifyProduct: false,
        ItemInfo : itemInfo
      }
      this.cartservice.GetDiliveryCost(payload).subscribe((res: any) => {
        this.loader.hide();
        if (res.StatusCode === 200) {
          this.deliveryCost = res.Data.ResponseData;
          this.diliverCostShow = true;
        }
      }, (err: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      });
    }
  }
  fn_ChckInventoryAvailablity(index: number) {
    this.CheckInventoryInStockModel = [];
    for (var i = 0; i < this.cartItems.length; i++) {
      if (this.cartItems[i].IsWareHouseProduct == true) {
        this.CheckInventoryInStockModel.push({
          ImpressSKU:this.cartItems[i].ImpressSKU,
          SizeName:this.cartItems[i].SizeName,
          Quantity:this.cartItems[i].Quantity
        });
      }
    }
    if (this.CheckInventoryInStockModel.length > 0){
      this.loader.show();
      this.cartservice.CheckAvailableInventoryForWareHouseProduct(this.CheckInventoryInStockModel).subscribe((res: any) => {
        if (res.StatusCode == 200) {
          if (res.Data.ResponseData.lenght > 0) {
            res.Data.ResponseData.forEach((item) => {
              var itm = this.cartItems.findIndex(x => x.ImpressSKU == item.ImpressSKU);
              this.cartItems[itm].Message = item.Message;
              this.cartItems[itm].StockOnHand = item.Quantity;
            });
          } else {
            this.selectedIndex = index;
          }
          this.loader.hide();
        } else{
          this.selectedIndex = index
        }
        if (res.StatusCode == 500) {
          this.notificationService.error(res.Message, "");
        }
      })
    } else {
      this.selectedIndex = index
      this.loader.hide();
    }





  }
  /** Func called on mat stepper Back/Previous button */
  goto(index: number, data: any): void {
    this.showBraintree = true;
    if (index === 1) {
      this.fn_ChckInventoryAvailablity(index);
    } else if (index === 2) {
      if(!this.order.AddressId || this.order.AddressId == 0){
        this.notificationService.error('No address selected', 'Address');
        return;
      }

      this.createBraintreeUI();
      this.loader.show();
      this.cartservice.CheckCartPrice(this.loginUserId, this.storeId).subscribe((res) => {
        if (res.StatusCode === 200) {
          this.fn_GetShippingCost();
          // If prices are not same, i.e store owner has changed the pricing so refresh the cart items pricing
          if (!res.Data.ResponseData) {
            this.notificationService.info(res.Message, 'Payment');
            this.selectedIndex = 0;
            this.fn_InitializeUpdateCartModal();
            this.fn_GetCartItems();
          } else if (res.Data.ResponseData) {  // If prices are same, than continue for payment
            this.selectedIndex = 2;
          }
          this.loader.hide();
        } else {
          this.selectedIndex = 0;
          this.loader.hide();
        }
      }, (error: any) => {
        this.selectedIndex = 1;
        this.loader.hide();
        if (error instanceof HttpErrorResponse) {
          this.errorhandlerService.handleError(error);
        } else {
          this.notificationService.error('An error occured. Try again', 'Payment');
        }
      });
    } else {
      this.selectedIndex = index;
    }

  }

  /* fun encrypt order id*/
  fn_CrytoEncryptDecryptText(orderid: any, ConversionText: any) {
    return this.EncrDecr.set(CryptoKeyValue.Key, String(orderid))
    //return this.EncrDecr.encryptData(String(orderid))

  }
}
